// @flow
export const TEXT_BLOCK: string & 'text-block' = 'text-block'
export const IMAGE: string & 'image' = 'image'
export const AUDIO: string & 'audio' = 'audio'
export const INSPIRATION: string & 'inspiration' = 'inspiration'
export const ENCOURAGEMENT: string & 'encouragement' = 'encouragement'
